// extracted by mini-css-extract-plugin
module.exports = {"noResults":"styles_noResults__3D0Jf","bookmarkIcon":"styles_bookmarkIcon__13DBy","link":"styles_link__3rnPP"};